export const sitemap = [
    {
        to: '/about',
        name: 'About'
    },
    {
        to: '/blog',
        name: 'Blog'
    },
    {
        to: '/community',
        name: 'Community'
    },
    {
        to: '/hiring',
        name: 'Hiring'
    },

    {
        to: '/api',
        name: 'Developers/API'
    },
    {
        to: '/press',
        name: 'Press'
    },
    {
        to: '/help',
        name: 'Help Center'
    },

    {
        to: '/education',
        name: 'Unsplash for Education'
    },
    {
        to: '/ios',
        name: 'Unsplash for iOS'
    },
    {
        to: '/official',
        name: 'Official Apps'
    },
]